import urlPrefixes from '../../../constants/urlPrefixes';

type TCategoriesParams = {
  l1Category?: {
    key?: string;
  };
  l2Category?: {
    key?: string;
  };
};

/**
 * create categories part for link generator
 * expected output: l/${l1-cat-name} || l/${l1-cat-name}/${l2-cat-name}
 * @param {{l1Category?: object, l2Category?: object}} categories object
 * @returns {string}
 */
export default function ({ l1Category, l2Category }: TCategoriesParams = {}) {
  const isL1CategoryValid = l1Category?.key;
  const isL2CategoryValid = l2Category?.key;
  const isValid = isL1CategoryValid || isL2CategoryValid;

  let part = isValid ? `/${urlPrefixes.baseCategoriesURL}` : '';
  part += isL1CategoryValid ? `/${l1Category?.key}` : '';
  part += isL2CategoryValid ? `/${l2Category?.key}` : '';

  return part;
}
